// @ts-nocheck
import React from "react";

import { Box, Typography, withStyles, createStyles } from "@material-ui/core";
import { surveyStyles, aboutUsStyle } from "./surveyStyles";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import PhoneNumber from "../../../../components/src/PhoneNumber.web";
import QuestionCard from "./layout/QuestionCard.web";
import StepFooter from "./layout/StepFooter.web";
import { MagicLinkTextField } from "./layout/FormFields.web";
import { MAGIC_LINK_PRIMARY } from "./layout/magicLinkTokens";
import { magicLinkFormOverrides } from "./layout/formStyleOverrides";
import { CONTACT_DETAILS_DESCRIPTION } from "./layout/stepSections";
const Schema = Yup.object().shape({
  email: Yup.string()
    .email("Email must be in valid format.")
    .required("This field is required.")
    .nullable(),
  firstName: Yup.string()
    .required("This field is required.")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed for this field")
    .nullable(),
  lastName: Yup.string()
    .required("This field is required.")
    .matches(/^[A-Za-z\s]+$/, "Only alphabets are allowed for this field")
    .nullable(),
  phoneNumber: Yup.string()
    .matches(
      /^(\+\d{0,3})?(\(\d{3}\)|\d{3})[\s-]??\d{3}-??\d{4}$/,
      "Invalid Phone number"
    )
    .required("This field is required")
    .nullable(),
  country_code: Yup.string()
});
export const AboutUsComponent = props => {
  const { classes, gotoBackStep, gotoNextStep } = props;
  const getHelpText = (errors, touched, key) => {
    return touched[key] && errors[key] ? errors[key] : "";
  };
  return (
    <Formik
      initialValues={{
        firstName: props.firstName,
        lastName: props.lastName,
        email: props.email,
        phoneNumber: props.phoneNumber,
        country_code: props.country_code
      }}
      validationSchema={Schema}
      enableReinitialize
      validateOnMount={true}
      onSubmit={() => {
        gotoNextStep();
      }}
    >
      {formikProps => {
        const {
          values,
          handleBlur,
          handleChange,
          errors,
          touched,
          isValid
        } = formikProps;
        const handleInputChange = event => {
          props.setValueByDynamicName(event.target.name, event.target.value);
          handleChange(event);
        };
        return (
          <Form autoComplete="off" noValidate style={{ margin: 0 }}>
            <QuestionCard
              title="What is the best way to reach you?"
              hint={CONTACT_DETAILS_DESCRIPTION}
            >
              <Box className={classes.contactFields}>
                <MagicLinkTextField
                  label="First Name"
                  name="firstName"
                  id="firstName"
                  placeholder="Enter your first name"
                  value={values.firstName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  error={getHelpText(errors, touched, "firstName")}
                />
                <MagicLinkTextField
                  label="Last Name"
                  name="lastName"
                  id="lastName"
                  placeholder="Enter your last name"
                  value={values.lastName}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  error={getHelpText(errors, touched, "lastName")}
                />
                <Box className={classes.fullWidth}>
                  <MagicLinkTextField
                    label="Email"
                    name="email"
                    id="email"
                    type="email"
                    placeholder="Enter a valid email"
                    disabled={props.isAboutusEnable}
                    value={values.email}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    error={getHelpText(errors, touched, "email")}
                  />
                </Box>
                <Box className={classes.fullWidth}>
                  <Typography className={classes.fieldLabel}>
                    Phone number
                  </Typography>
                  <Field name="phoneNumber">
                    {({ form }: any) => (
                      <PhoneNumber
                        countryCode={form.values.country_code}
                        phoneNumber={form.values.phoneNumber}
                        onChange={(code, number) => {
                          form.setFieldValue("country_code", code);
                          form.setFieldValue("phoneNumber", number);
                          props.setValueByDynamicName("country_code", code);
                          props.setValueByDynamicName("phoneNumber", number);
                        }}
                        isSurvey={true}
                        variant="magicLink"
                        accentColor={props.iconColor || MAGIC_LINK_PRIMARY}
                      />
                    )}
                  </Field>
                </Box>
              </Box>
            </QuestionCard>
            <StepFooter
              onBack={gotoBackStep}
              backId="backButton"
              nextType="submit"
              nextId="nextButton"
              nextDisabled={!isValid}
            />
          </Form>
        );
      }}
    </Formik>
  );
};
export default withStyles(theme =>
  createStyles({
    ...surveyStyles(theme),
    ...aboutUsStyle(theme),
    ...magicLinkFormOverrides(theme),
    contactFields: {
      display: "grid",
      gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      gap: "16px 32px",
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)"
      }
    },
    fullWidth: {
      gridColumn: "1 / -1"
    }
  })
)(AboutUsComponent);
